// Teléfono con su código de área aparte (+1, +506, +58), como lo guardan
// Infoauto (cod_area) y las direcciones (phone_area_code).
export function formatPhone(areaCode, number) {
  return [areaCode, number].filter(Boolean).join(" ");
}
